import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SearchErrorProps {
  /** What failed to load, e.g. 'arches'. Used in the message. */
  subject: string;
  message: string;
  onRetry: () => void;
}

/**
 * Shown when a marketplace search fails. Without this a failed request renders
 * the grid's "No arches found" empty state, which tells the user their search
 * matched nothing when in fact it never ran.
 */
export function SearchError({ subject, message, onRetry }: SearchErrorProps) {
  return (
    <div className="text-center py-12" role="alert">
      <AlertCircle className="h-8 w-8 mx-auto mb-3 text-destructive" aria-hidden="true" />
      <p className="text-foreground font-medium">Couldn't load {subject}</p>
      <p className="text-sm text-muted-foreground mt-1">{message}</p>
      <Button variant="outline" size="sm" className="mt-4" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
